export default {
    /**
     * Wordpress
     */
    WORDPRESS: 'wordpress',
    /**
     * Woocommerce
     */
    WOOCOMMERCE: 'woocommerce',
};
